import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import http from '@lib/http-client'
import { NutritionStore } from './types'

export const useNutritionStore = create<NutritionStore>()(
  devtools(set => ({
    getNutritionMonthlySummary: async (
      userId: number,
      month: string,
      year: number
    ) => {
      try {
        const response = await http.get(
          `/user/${userId}/meals-month-summary?month=${month}&year=${year}`
        )
        return response
      } catch (error) {
        console.log('getNutritionDailySummary error', error)
        return null
      }
    },
    getNutritionDailySummary: async (userId: number, date: string) => {
      try {
        const response = await http.get(`/user/${userId}/meals-day?day=${date}`)
        return response
      } catch (error) {
        console.log('getNutritionDailySummary error', error)
        return null
      }
    },
    getIconUrl: (iconId: string, size: number) => {
      const base_url =
        'https://storage.googleapis.com/passio-prod-env-public-cdn-data/label-icons/%s-%d.jpg'
      return base_url.replace('%s', iconId).replace('%d', size.toString())
    }
  }))
)
